import BCheckpanel from "./BCheckpanel";
import MApp from "./MApp";
import MForm from "./MForm";
import MRequest from "./MRequest";
import MScroll from "./MScroll";

export default class BProfileSetupProductForm extends MForm
{
	static selector = () => `.b-profile-setup-ZIVOT20-form`;

	static addEventListeners()
	{
		document.addEventListener("submit", event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const profileSetupDiabetesForm = new this(event.target);
				profileSetupDiabetesForm.getResult();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()} button, ${this.selector()} button *`)) {
				event.preventDefault();

				const profileSetupDiabetesForm = new this(event.target.closest(this.selector()));
				profileSetupDiabetesForm.getResult();
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`.b-profile-setup-ZIVOT20-form__sport-durations [type="checkbox"]`)) {
				let checked = 0;
				document.querySelectorAll(`.b-profile-setup-ZIVOT20-form__sport-duration`).forEach(el => {
					checked += el.checked ? 1 : 0;
				});

				document.querySelector(`.b-profile-setup-ZIVOT20-form__sport-duration-none`).checked = (checked ? false : true);
				MApp.refresh();
				document.querySelectorAll(BCheckpanel.selector()).forEach(el => {
					new BCheckpanel(el).refreshState();
				});
			}
		});

		/**************************************************************************
		 * Exception warning.
		 */
		 document.addEventListener("change", event => {
			if (event.target.matches(`[name="diagnosis_type"]`)) {
				const box = event.target.closest(`.b-box`);
				box.querySelectorAll(`.b-profile-setup-ZIVOT20-form__diagnosis-exception-warning`).forEach(el => el.hidden = true);
				if (["iddm", "iddm_lada", "gdm"].includes(event.target.value)) {
					box.querySelector(`.b-profile-setup-ZIVOT20-form__diagnosis-exception-warning`).hidden = false;
				}
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="maternity_scenario"]`)) {
				const box = event.target.closest(`.b-box`);
				box.querySelectorAll(`.b-profile-setup-ZIVOT20-form__diagnosis-exception-warning`).forEach(el => el.hidden = true);
				if (["pregnant", "breastfeeding"].includes(event.target.value)) {
					box.querySelector(`.b-profile-setup-ZIVOT20-form__diagnosis-exception-warning`).hidden = false;
				}
			}
		});
	}

	getResult()
	{
		const url = this.getUrl();
		const data = this.getData();

		this.resetErrors();
		this.disable();

		MRequest.post(url, data).then(response => {
			MApp.redirect(response.data.redirectUrl);
		}).catch(error => {
			this.setErrorResponse(error);
			MScroll.top(this.el);
		}).finally(() => {
			this.enable();
		});
	}
}
